module.exports = __webpack_public_path__ + "img/user.b6fb07b9.svg";